<div class="container" [@fadeInOut]="state">
  <div class="title-container">
    <h5>{{ title.split(' ')[0] }} {{ title.split(' ')[1] }}<span [style]="{ 'font-style': 'italic' }"> {{ title.split(' ')[2] }}</span></h5>
    <input
      #input
      (blur)="deleteTrim(input.value, input)"
      (input)="getText(input.value)"
      [(ngModel)]="lod_title"
      type="text"
    />
    <p-button
      (onClick)="deleteView()"
      icon="pi pi-trash"
      [rounded]="true"
      severity="danger"
      [style]="{ 'border-radius': '50%', width: '35px', height: '35px' }"
    ></p-button>
  </div>
  <hr />
  <div class="container">
    <app-subtitle-block #firstComponent [first]="true"></app-subtitle-block>
    <ng-container #view> </ng-container>
  </div>

  <br />
  <div class="title-container">
    <!-- <p-button
      (onClick)="generate()"
      label="Agregar subtitulo"
      icon="pi pi-plus"
      [rounded]="true"
      severity="secondary"
      [style]="{ 'border-radius': '40px', 'margin-top': '10px' }"
    ></p-button> -->
  </div>
</div>
